const CHANGE_FEEDBACK_CONDITIN = 'CHANGE_FEEDBACK_CONDITIN';
const CHANGE_FEEDBACK_PAGE = 'CHANGE_FEEDBACK_PAGE';
const CHANGE_PROCUCT_KINDS_LIST = 'CHANGE_PROCUCT_KINDS_LIST';
const CHANGE_NEW_FEEDBACK_CONDITION = 'CHANGE_NEW_FEEDBACK_CONDITION';
const CHANGE_DEAL_FEEDBACK_CONDITION = 'CHANGE_DEAL_FEEDBACK_CONDITION';
const FEEDBACK_ADD_CONDITION = 'FEEDBACK_ADD_CONDITION';

const FeedBackListModel = function (){
    const name = 'feedback_list';
    return {
        name,
        state:{
            condition:{
                mobile:'',
                fbType:'',
            //     status:'',
            //     searchCode:'',
                dealStatus:'',
            },
            newModal:{
                linkName:'',
                mobile:'',
                fbType:'',
                userId:'',
                content:'',
                status:'',
                dealStatus:'',
            },
            dealModal:{
                dealUserId:'',
                remark:'',
                dealStatus:'',
            },
            addCondition:{   //更新为优惠券列表模态框的搜索条件
                productName:'',
                title:'',
                type:'',
            },
            list:[],
            page:{
                pageSize:30,
                current:1,
                total:0,
            },
            // personList:[]
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
                getNewModalData:()=>currentState.newModal,
                getDealModalData:()=>currentState.dealModal,
                getList:()=>currentState.list,
                getPage:()=>currentState.page,
                getAddCondition: () => currentState.addCondition,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_FEEDBACK_CONDITIN,
                    key,
                    value
                })
            },
            changeNewModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_NEW_FEEDBACK_CONDITION,
                    key,
                    value
                })
            },
            changeDealModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_DEAL_FEEDBACK_CONDITION,
                    key,
                    value
                })
            },
            changeList:(list) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_PROCUCT_KINDS_LIST,
                    list
                })
            },
            changePage:(page) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_FEEDBACK_PAGE,
                    page
                })
            },
            changeAddCondition: (key, value) => (dispatch, getState) => {
                dispatch({
                    type: FEEDBACK_ADD_CONDITION,
                    key,
                    value
                });
            }
        },
        reducers:{
            condition:(state = FeedBackListModel.state.condition, action) => {
                if(action.type === CHANGE_FEEDBACK_CONDITIN){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newModal:(state = FeedBackListModel.state.newModal, action) => {
                if(action.type === CHANGE_NEW_FEEDBACK_CONDITION){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            dealModal:(state = FeedBackListModel.state.dealModal, action) => {
                if(action.type === CHANGE_DEAL_FEEDBACK_CONDITION){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page:(state = FeedBackListModel.state.page, action) => {
                if(action.type === CHANGE_FEEDBACK_PAGE){
                    return Object.assign({}, state, action.page );
                }
                return state;
            },
            list:(state = FeedBackListModel.state.list , action ) => {
                if(action.type === CHANGE_PROCUCT_KINDS_LIST){
                    return [ ...action.list ];
                };
                return state;
            },
            addCondition: (state = FeedBackListModel.state.addCondition, action) => {
                if (action.type === FEEDBACK_ADD_CONDITION) {
                    const { key, value } = action;
                    let obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            }
        }
    }
}();

export default FeedBackListModel;


// WEBPACK FOOTER //
// ./src/models/FeedBackListModel.js